import type { Route } from '@angular/router';
import { ForbiddenNicknameListComponent } from './list/forbidden-nickname-list.component';

export const forbiddenNicknameRoutes: Route[] = [
  {
    path: '',
    component: ForbiddenNicknameListComponent,
    pathMatch: 'full',
  },
];
